/**
 * 加载脚本并重试
 * @param {string} url -
 * @param {number} repeat -
 * @param {function} cb -
 * @return {void}
 */
const loadScript = (url, repeat, cb) => {
    const _script = document.createElement('script');
    const head = document.head || document.getElementsByTagName('head')[0];
    _script.src = url;
    _script.crossOrigin = "anonymous";
    _script.onerror = (error) => {
      // console.error(`load script error. url:${url}.`, error);
      head.removeChild(_script);
      if (repeat-- < 1) {
        cb(error);
      } else {
        setTimeout(() => loadScript(url, repeat, cb), 300);
      }
    };
    _script.onload = () => {
      // console.info(`load script success. url:${url}.`);
      cb('success');
    };
    head.appendChild(_script);
  };
  
  /**
   * 加载脚本并重试
   * @param {string} url -
   * @param {number} repeat -
   * @param {function} cb -
   * @return {void}
   */
  const loadCss = (url, repeat, cb) => {
    const link = document.createElement('link');
    const head = document.head || document.getElementsByTagName('head')[0];
    link.href = url;
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.onerror = (error) => {
      // console.error(`load script error. url:${url}.`, error);
      head.removeChild(link);
      if (repeat-- < 1) {
        cb(error);
      } else {
        setTimeout(() => loadCss(url, repeat, cb), 300);
      }
    };
    link.onload = () => {
      // console.info(`load script success. url:${url}.`);
      cb('success');
    };
  
    head.appendChild(link);
  };
  
  /**
   * 缓存相同链接的回调
   * @type {{}}
   */
  const cache = {};
  const successCache = {};
  
  export default function (url) {
    return function (repeat = 10) {
      return new Promise((resolve, reject) => {
  
        if (successCache[url]) {
          resolve()
          return
        }
  
        let cacheOfUrl = cache[url];
        if (!cacheOfUrl) {
          cacheOfUrl = cache[url] = [];
          //timeout是为了躲避load的统计，页面加载时间不会因为这些js而受影响
          setTimeout(()=> {
            let loadFunc = loadScript
            if (url.indexOf(".css") !== -1) {
              loadFunc = loadCss
            }
            loadFunc(url, repeat, (res) => {
              cache[url].forEach((cb) => {
                res === 'success' ? cb.resolve() : cb.reject(res);
              });
  
              if (res === 'success') {
                successCache[url] = true
              }
  
              // 刘小光觉得下面这行代码不应该加上，因为如果同一个js 执行了多次，那就会创建多次dom
              delete cache[url];
            });
          })
  
        }
        //先将重复的脚本加载回调缓存起来，等脚本加载完毕后统一回调
        cacheOfUrl.push({resolve, reject});
      });
    };
  }
  